
<div class="sk-cms-meeting-box-wap"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>

    {{if style.isShowTitle == '1'}}
        <% include('../common/title.art', {title: basic.title, terminal: 'title-wap'}) %>
    {{/if}}

    {{if !content.items || !content.items.length}}
         <% include('../common/nodata.art') %>
    {{else}}
    {{if style.moreStyle.styleType != 'hide' && isMain != 1}}
    <div class="sk-cms-more-wap">

            <div class="more sk-cms-more-dom">
                {{if isDesign}}
                    <span class="more-btn {{style.moreStyle.styleType == 'default'?'medium':style.moreStyle.fontSize}}" style="{{style.moreStyle.styleType == 'default' ? '': 'color:' + style.moreStyle.color}}">MORE >></span>
                {{else}}
                    <a class="more-btn goto-link {{style.moreStyle.styleType == 'default'?'medium':style.moreStyle.fontSize}}" style="{{style.moreStyle.styleType == 'default' ? '': 'color:' + style.moreStyle.color}}" href="{{isPreview ? content.moreLink: content.morePage}}">MORE >></a>
                {{/if}}
            </div>

    </div>
    {{/if}}
    <div class="sk-cms-meeting-list-wap {{basic.columns.type}}"> <!--column2 column3 column4 一二三四列-->
    {{each content.items}}
        <div class="meeting-item-wap {{style.lineStyle.model != 'hide' ? 'border-'+ style.lineStyle.line : ''}} {{basic.style.type}}" style="border-color: {{style.lineStyle.color}};">
        {{if $value.linkType != 'none' && !isDesign}}
             <a class="content-link goto-link" target="_blank" href="{{$value.link}}">
        {{/if}}
            <img class="poster" src="{{$value.imgUrl? $value.imgUrl: '../../assets/images/img_default.jpg'}}" alt="" cms-smarket>
            <div class="info {{basic.style.type == 'layout-img-top' && style.button.styleType == 'hide'? 'no-bottom': ''}}">
                {{if style.titleStyle.styleType != 'hide'}}
                <div class="title {{style.titleStyle.styleType == 'default'?'medium':style.titleStyle.fontSize}}"
                    style="{{style.titleStyle.styleType == 'default' ? '': 'color:' + style.titleStyle.color}}">
                    {{$value.title}}
                </div>
                {{/if}}
                {{if style.timeStyle.styleType != 'hide'}}
                    <span class="date {{style.timeStyle.styleType == 'default'?'medium':style.timeStyle.fontSize}}" style="{{style.timeStyle.styleType == 'default' ? '': 'color:' + style.timeStyle.color}}">{{$value.pushTime}}</span>
                {{/if}}
                {{if style.button.styleType != 'hide'}}
                    <span class="subscribe {{style.button.styleType == 'default'?'medium':style.button.fontSize}}"
                         style="{{style.button.styleType == 'custom' ? 'color: '+style.button.color+'; background: url(\''+style.button.imgUrl+'\') '+style.button.backgroundColor +'; ' : ''}}">
                        {{content.buttonText}}
                    </span>
                {{/if}}
            </div>
        {{if $value.linkType != 'none' && !isDesign}}
            </a>
        {{/if}}
        </div>
    {{/each}}
    </div>
    {{/if}}
    {{if isMain == 1}}
        <% include('../common/pagination.art') %>
    {{/if}}
</div>
